
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class DataTableField extends Vue {
  @Prop() value!: any;
  @Prop({required: true}) title!: string;
  @Prop({default: () => []}) items!: any[];
  @Prop({default: () => []}) headers!: [];
  @Prop({default: 'required'}) rules!: string;
  @Prop({default: 'Data Table'}) name!: string;
  @Prop({default: 'isSelectable'}) selectableKey!: string;

  search = '';

  selected = [];

  get itemList() {
    return this.items || [];
  }

  @Watch('value', {immediate: false})
  onValueChanged(val: any) {
    if (val) {
      this.selected = val;
    }
  }

  @Watch('selected', {deep: false})
  onSelectedChanged(val: any) {
    this.$emit('input', val);
  }
}
